// Referral system
export const REFERRAL_COOKIE_NAME = 'quantwheel_ref';
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days in seconds
export const COMMISSION_PER_PAID_USER = 40; // Commission amount in dollars 
// Analytics
export const ANON_ID_COOKIE_NAME = 'options_anon_id';